/* eslint-disable @typescript-eslint/no-explicit-any */

import { SharedAppConstants } from '@tock/shared-app-constants';
import { assign } from 'es-toolkit/compat';
import protos from 'utils/protos';

const { UrgentHelpRequest } = protos;

export function requestHelp(
  formValues: any,
  currentBuildNumber = 'undefined',
  newBuildNumber = 'undefined'
): ApiAction {
  const values = assign({}, formValues, {
    currentBuildNumber,
    newBuildNumber,
  });
  const request = UrgentHelpRequest.fromObject(values);

  return {
    TockApi: {
      postProto: '/business/help',
      request,
      type: SharedAppConstants.NULL,
      toast: 'Your support request has been sent. We will respond as soon as we can.',
    },
  };
}
